module.exports = __webpack_public_path__ + "static/dd-madde2-d45eeeb7c9ad2521590eae6dd1eecff9.png";